/**
 * e.g. getScopedCookieKey('some-cookie', 'zakelijk', 'mijn') will return 'some-cookie:zakelijk:mijn'
 * @param cookieKey
 * @param scopes
 */
export function getScopedCookieKey(cookieKey: string, ...scopes: string[]) {
  return `${cookieKey}${scopes.map((scope) => `-${scope}`).join('')}`;
}
